import { render, staticRenderFns } from "./principalMenuItem.vue?vue&type=template&id=79d96c32&scoped=true"
import script from "./principalMenuItem.vue?vue&type=script&lang=js"
export * from "./principalMenuItem.vue?vue&type=script&lang=js"
import style0 from "./principalMenuItem.vue?vue&type=style&index=0&id=79d96c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d96c32",
  null
  
)

export default component.exports